import { render, staticRenderFns } from "./DepartmentSelector.vue?vue&type=template&id=446dd584&scoped=true&"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSelector.vue?vue&type=style&index=0&id=446dd584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446dd584",
  null
  
)

export default component.exports